export const company = {
  legalName: 'Universal Packaging Industries LLC',
  shortName: 'Universal Packaging',
  logoHeader: 'https://cdn.magicpatterns.com/uploads/kHQxuse5PE3fpnB3gRou6a/Universal.png',
  logoWhite: 'https://cdn.magicpatterns.com/uploads/bu5XwzJqHKR9uvAXxZTv42/Universal_(3).png',
  logoColor: 'https://cdn.magicpatterns.com/uploads/eY3rrzyzUkwApFQsJXTjQP/Universal_(6).png',
  address: 'Plot No. 0356, Umm Dera, New Industrial Area, Umm Al Quwain, UAE',
  addressLines: ['Plot No. 0356, Umm Dera', 'New Industrial Area', 'Umm Al Quwain, UAE'],
  phone: '+971 6 740 5526',
  phoneHref: 'tel:+97167405526',
  email: 'info@universalpkgindllc.com',
  emailHref: 'mailto:info@universalpkgindllc.com',
  footerBlurb:
    'Universal Packaging Industries LLC manufactures paper cores and stretch film in Umm Al Quwain, UAE. With over 25 years in packaging, we also supply film and paper materials to businesses in the UAE, Oman and Saudi Arabia.',
  mapEmbed:
    'https://www.google.com/maps?q=Umm+Dera+New+Industrial+Area+Umm+Al+Quwain+UAE&output=embed',
  directions:
    'https://www.google.com/maps/dir/?api=1&destination=Umm+Dera+New+Industrial+Area+Umm+Al+Quwain+UAE',
};

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Products', to: '/products' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'Contact Us', to: '/contact' },
];
